// src/routes/routeDefinitions.ts
import React from "react";
import LoginPage from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import SetNewPassword from "../pages/auth/SetNewPassword";
import PasswordChanged from "../pages/auth/PasswordChanged";
import Dashboard from "../pages/dashboard";
import ListofAdmins from "../pages/AdminManagement/ListofAdmins";
import AddAdmin from "../pages/AdminManagement/AddAdmin";
import ViewAdminDetails from "../pages/AdminManagement/ViewAdminDetails";
import OtherResources from "../pages/OtherResources/Banks";
import { Addbank } from "../pages/OtherResources/Banks/Addbank";
import RegionalOffice from "../pages/OtherResources/RegionalOffice";
import AddRegionalOffice from "../pages/OtherResources/RegionalOffice/AddRegionalOffice";
import NotFound from "../components/Notfound/Notfound";
import AddMD from "../pages/UserManagement/MasterDistributorManagement/AddMD";
import ListOfMasterDistributors from "../pages/UserManagement/MasterDistributorManagement/ListofMasterDistributor";
import ViewMasterDistributor from "../pages/UserManagement/MasterDistributorManagement/ViewMasterDistributor";
import ListofMNOs from "../pages/MNOManagament/ListofMNOs";
import AddMNO from "../pages/MNOManagament/AddMNO";
import ViewMnoDetails from "../pages/MNOManagament/ViewMnoDetails";
import ListofPurchasedAmount from "../pages/MNOManagament/ListOfPurchasedAmount";
import AddManual from "../pages/MNOManagament/AddManual";
import ViewManual from "../pages/MNOManagament/ViewManual";
import PayDueBill from "../pages/MNOManagament/PayDueBill";
import ListOfAchievements from "../pages/MNOManagament/OnTargetAchievement/ListOfAchievements";
import AddOnTargetAchievement from "../pages/MNOManagament/OnTargetAchievement/AddOnTargetAchievement";
import ETopUpRequest from "../pages/RaiseETopUpRequest";
import AddMnoTarget from "../pages/MNOManagament/OnTargetAchievement/AddMnoTarget";
import PayAdvance from "../pages/RaiseETopUpRequest/PayAdvance";
import ListOfServiceFeeTransaction from "../pages/MNOManagament/ServiceFeeTransaction/ListOfServiceFeeTransaction";
import ETopUpRequestList from "../pages/Profile/RequestRaised";
import ETopUpView from "../pages/Profile/RequestRaised/ETOpUpView";
import OnboardingRequest from "../pages/OnboardingRequest/ListOfOnboardingRequest";
import ViewOnBoardingRequests from "../pages/OnboardingRequest/ViewOnboardingRequest";
import ETopUpTransactionsLists from "../pages/Profile/RequestRaised/ETopUpTransactionsLists";
import AddCVM from "../pages/UserManagement/MasterDistributorManagement/Components/AddCVM";
import Recharge from "../pages/Services/Recharge";
import ListofCompanies from "../pages/CompanyManagement/ListofCompanies";
import AddCompany from "../pages/CompanyManagement/AddCompany";
import ViewCompanyDetails from "../pages/CompanyManagement/ViewCompanyDetails";
interface RouteDefinition {
    path: string;
    element: React.FC<any>; // Component for rendering
    props?: Record<string, any>; // Optional props for the component
    privilege?: any; // Optional privilege required for the route
}

export const unauthenticatedRoutes: RouteDefinition[] = [
    { path: "/", element: LoginPage },
    { path: "/forgot-password", element: ForgotPassword },
    { path: "/set-new-password", element: SetNewPassword },
    { path: "/password-changed", element: PasswordChanged },
    { path: "/expired", element: PasswordChanged }, // Duplicate reference for simplicity
];

export const authenticatedRoutes: RouteDefinition[] = [
  {
    path: "/dashboard",
    element: Dashboard,
    privilege: [
      "D1",
      "D2",
      "D3",
      "D4",
      "D5",
      "D6",
      "D7",
      "D8",
      "D9",
      "D10",
      "D11",
      "D12",
      "D13",
      "D14",
      "D15",
      "D16",
      "D17",
      "D18",
    ],
  },
  {
    path: "/admin-management/list-of-admins",
    element: ListofAdmins,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins/add-admin",
    element: AddAdmin,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins/view-admin/:id",
    element: ViewAdminDetails,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins/edit-admin/:id",
    element: AddAdmin,
    privilege: "allowed",
  },
  {
    path: "/admin-management/view-admin-profile/edit-admin/:id",
    element: AddAdmin,
    privilege: "allowed",
  },
  {
    path: "/user-management/master-distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["MDM1", "MDM4"],
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["DM1", "DM4"],
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["SDM1", "SDM4"],
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management",
    element: ListOfMasterDistributors,
    privilege: ["AM1", "AM4"],
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management",
    element: ListOfMasterDistributors,
    privilege: ["RM1", "RM4"],
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management",
    element: ListOfMasterDistributors,
    privilege: ["CM1", "CM4"],
    props: { type: "Customers" },
  },
  {
    path: "/user-management/master-distributor-management/add-master-distributor",
    element: AddMD,
    privilege: "MDM4",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/master-distributor-management/add-master-distributor/add-cvm",
    element: AddCVM,
    privilege: "allowed",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/add-sub-distributor",
    element: AddMD,
    privilege: "SDM4",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management/add-agent",
    element: AddMD,
    privilege: "AM4",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management/add-retailer",
    element: AddMD,
    privilege: "RM4",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management/add-customer",
    element: AddMD,
    privilege: "AM4",
    props: { type: "Customers" },
  },
  {
    path: "/user-management/sub-distributor-management/edit-sub-distributor/:id",
    element: AddMD,
    privilege: "MDM5",
    props: { type: "Sub Distributors", edit: true },
  },
  {
    path: "/user-management/agent-management/edit-agent/:id",
    element: AddMD,
    privilege: "AM2",
    props: { type: "Agents", edit: true },
  },
  {
    path: "/user-management/retailer-management/edit-retailer/:id",
    element: AddMD,
    privilege: "RM2",
    props: { type: "Retailers", edit: true },
  },
  {
    path: "/user-management/distributor-management/add-distributor",
    element: AddMD,
    privilege: "DM4",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "MDM2",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "DM6",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "SDM6",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id",
    element: ViewMasterDistributor,
    privilege: "AM6",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id",
    element: ViewMasterDistributor,
    privilege: "RM6",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management/view-customer/:id",
    element: ViewMasterDistributor,
    privilege: "CM6",
    props: { type: "Customers" },
  },
  {
    path: "/other-resources/banks",
    element: OtherResources,
    privilege: "allowed",
  },
  {
    path: "/other-resources/banks/add-bank",
    element: Addbank,
    privilege: "allowed",
    props: { edit: false },
  },
  {
    path: "/other-resources/banks/edit-bank/:id",
    element: Addbank,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/other-resources/regional-offices",
    element: RegionalOffice,
    privilege: "allowed",
  },
  {
    path: "/other-resources/regional-offices/add-regional-office",
    element: AddRegionalOffice,
    privilege: "allowed",
    props: { edit: false },
  },
  {
    path: "/other-resources/regional-offices/edit-regional-office/:id",
    element: AddRegionalOffice,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/",
    element: Dashboard,
    privilege: [
      "D1",
      "D2",
      "D3",
      "D4",
      "D5",
      "D6",
      "D7",
      "D8",
      "D9",
      "D10",
      "D11",
      "D12",
      "D13",
      "D14",
      "D15",
      "D16",
      "D17",
      "D18",
    ],
  },
  {
    path: "/user-management/master-distributor-management/edit-master-distributor/:id",
    element: AddMD,
    privilege: "MDM5",
    props: { edit: true, type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management/edit-distributor/:id",
    element: AddMD,
    privilege: "DM2",
    props: { edit: true, type: "Distributors" },
  },
  {
    path: "/user-management/customer-management/edit-customer/:id",
    element: AddMD,
    privilege: "CM2",
    props: { edit: true, type: "Customers" },
  },
  // MNO Management Routes
  {
    path: "/mno-management/list-of-mnos",
    element: ListofMNOs,
    privilege: ["MM1", "MM4"],
  },
  {
    path: "/mno-management/list-of-mnos/add-mno",
    element: AddMNO,
    privilege: "MM4",
  },
  {
    path: "/mno-management/list-of-mnos/edit-mno/:id",
    element: AddMNO,
    privilege: "MM2",
    props: { edit: true },
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id",
    element: ViewMnoDetails,
    privilege: "MM6",
    // props: { type: "Distributors" }
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement",
    element: ListOfAchievements,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/service-fee-transaction",
    element: ListOfServiceFeeTransaction,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target",
    element: AddMnoTarget,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target/:targetId",
    element: AddMnoTarget,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target-achievement/:dataId",
    element: AddOnTargetAchievement,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction",
    element: ListofPurchasedAmount,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/add-manual",
    element: AddManual,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/view-manual/:purchaseId",
    element: ViewManual,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/pay-due-bill/:dataId",
    element: PayDueBill,
    privilege: "allowed",
  },
  {
    path: "/raise-e-top-up-request",
    element: ETopUpRequest,
    privilege: "admin-allowed",
  },
  {
    path: "/raise-e-top-up-request/:tab",
    element: ETopUpRequest,
    privilege: "admin-allowed",
  },
  {
    path: "/raise-e-top-up-request/pay/:id",
    element: PayAdvance,
    privilege: "admin-allowed",
  },
  // {
  //     path: "/e-top-up-request",
  //     element: ETopUpRequestList,
  //     privilege: "supper-admin"
  // },
  {
    path: "/e-top-up-request/:tab",
    element: ETopUpRequestList,
    privilege: "supper-admin",
  },
  {
    path: "/e-top-up-request/e-top-up/:id",
    element: ETopUpView,
    privilege: "super-admin",
    props: { default: true },
  },
  {
    path: "/e-top-up-request/transactions/:id",
    element: ETopUpTransactionsLists,
    privilege: "super-admin",
    props: { default: true },
  },

  // Onboarding Request
  {
    path: "/onboarding-request",
    element: OnboardingRequest,
    privilege: ["OR1", "OR4"],
  },
  {
    path: "/onboarding-request/:tab",
    element: OnboardingRequest,
    privilege: ["OR1", "OR4"],
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/master-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Master Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/master-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Master Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/agent/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Agents", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/agent/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Agents", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/sub-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Sub Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/sub-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Sub Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/retailer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Retailers", tab: "Onboarding" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/customer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Customers", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/retailer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Retailers", tab: "Modification" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/customer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Customers", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/temporary-user/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Temporary Users", tab: "Onboarding" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/master-distributor/:id",
    element: AddMD,
    privilege: "OR2",
    props: {
      type: "Master Distributors",
      edit: true,
      tab: "Onboarding Requests",
    },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/agent/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Agents", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Distributors", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/sub-distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Sub Distributors", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/modification-request/:tab/edit-modification-request/sub-distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: {
      type: "Sub Distributors",
      edit: true,
      tab: "Modification Requests",
    },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/retailer/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Retailers", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/temporary-user/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Temporary Users", edit: true, tab: "Onboarding Requests" },
  },
  // Recharge flow
  {
    path: "/services/recharge",
    element: Recharge,
    privilege: ["S1", "S2"],
  },
  {
    path: "*",
    element: NotFound,
    privilege: "allowed",
    props: { default: true },
  },

  //company mangement
  {
    path: "/company-management",
    element: ListofCompanies,
    privilege: ["CMGT1", "CMGT4"],
  },
  {
    path: "/company-management/add-company",
    element: AddCompany,
    privilege: ["CMGT4"],
  },
  {
    path: "/company-management/view-company/:id",
    element: ViewCompanyDetails,
    privilege: ["CMGT2"],
  },
  {
    path: "/company-management/edit-company/:id",
    element: AddCompany,
    privilege: ["CMGT3"],
    props: { edit: true },
  },
  {
    path: "/company-management/view-company/edit-company/:id",
    element: AddCompany,
    privilege: ["CMGT3"],
    props: { edit: true },
  },
]; 

